import { LegalLayout } from "./PrivacyPage";

const Block = ({ title, children }) => (
    <div className="border-t border-linen py-8 first:border-t-0">
        <h2 className="font-serif text-xl uppercase tracking-tight text-ink">{title}</h2>
        <div className="mt-3 max-w-3xl space-y-3 text-sm leading-relaxed text-mute">{children}</div>
    </div>
);

export default function TermsPage() {
    return (
        <LegalLayout eyebrow="Legal" title="Terms of Service" updated="July 2026">
            <Block title="The service">
                <p>
                    Summercrest AI designs and operates client reactivation and rebooking systems for cosmetic
                    and aesthetic clinics. The scope, timelines and deliverables of any engagement are agreed in
                    writing before work begins.
                </p>
            </Block>
            <Block title="Website content">
                <p>
                    The content on this website is general information about our services. Visuals showing client
                    journeys, messages, calendars and revenue flows are illustrative demonstrations of how the
                    system works — they are not promises of specific results, and we do not publish invented
                    performance statistics.
                </p>
            </Block>
            <Block title="No guaranteed outcomes">
                <p>
                    Reactivation results depend on each clinic’s database quality, services, pricing and consent
                    basis. We commit to tracking rebookings generated through the system, not to guaranteeing a
                    specific volume of appointments or revenue.
                </p>
            </Block>
            <Block title="Clinic responsibilities">
                <p>
                    Clinics are responsible for the accuracy of their client data, the lawfulness of their
                    communication permissions, and the approval of messaging tone and content before campaigns
                    go live.
                </p>
            </Block>
            <Block title="Intellectual property">
                <p>
                    The Summercrest AI name, logo and website design are our property. Systems built for a clinic
                    are licensed for that clinic’s use for the duration of the engagement, as set out in the
                    engagement agreement.
                </p>
            </Block>
            <Block title="Contact">
                <p>
                    Questions about these terms can be raised on a discovery call before any engagement begins.
                </p>
            </Block>
        </LegalLayout>
    );
}
